import {DateRange} from '@/dateUtils/DateRange'
import {Ref} from 'vue'

// TODO seems stupid, please find better solution
export const ensureUTC = (range: Ref<DateRange>) => {
    range.value = {
        start: new Date(Date.UTC(range.value.start.getFullYear(), range.value.start.getMonth(), range.value.start.getDate())),
        end: new Date(Date.UTC(range.value.end.getFullYear(), range.value.end.getMonth(), range.value.end.getDate()))
    }
}